/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../../components'
import { AttributeVariableForm } from '../../AttributeVariableForm'

export const AttributeVariableDialogUpdate = ({
  currentProject,
  currentScenario,
  actionUpdateDispatch,
  openDialog,
  setOpenDialog,
  variable
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.variables.update.scenario')
    : currentProject
    ? t('attributes.variables.update.project')
    : t('attributes.variables.update.global')

  /**
   * Action received from the Variable Form.
   * @see AttributeVariableForm
   *
   * @param {object} newVariable Variable attribute object to update.
   * @param {string} newVariableId Variable attribute Id to update.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newVariable, newVariableId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeVariableDialogUpdate.onDispatchAction()', {
      newVariable,
      newVariableId
    })

    dispatch(actionUpdateDispatch(newVariable, newVariableId, currentProject?.id, currentScenario?.id))
      .then((res) => {
        Logger.trace(
          LoggerTypes.CONTROLLER,
          'AttributeVariableDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).then()',
          {
            res
          }
        )
        if (res?.data?.isAxiosError) {
          enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
        } else if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
      })
      .catch((res) => {
        Logger.trace(
          LoggerTypes.WARN,
          'AttributeVariableDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).catch()',
          { res }
        )

        checkErrorResponse(res, enqueueSnackbar, t)

        if (res?.response?.data?.fields) {
          setErrors(res.response.data.fields)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeVariableDialogUpdate.render()', {
    currentProject,
    currentScenario,
    variable
  })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeVariableForm
        title={title}
        setOpenDialogVariable={setOpenDialog}
        variable={variable}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeVariableDialogUpdate.displayName = 'AttributeVariableDialogUpdate'

AttributeVariableDialogUpdate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionUpdateDispatch: PropTypes.func.isRequired,
  variable: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    initial_value: PropTypes.number,
    units: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
}

AttributeVariableDialogUpdate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionUpdateDispatch: null,
  variable: {
    name: '',
    description: '',
    initial_value: '',
    type: null,
    unit: ''
  }
}
